import { measureLatency } from '../../gctl-measure';
import { NetworkError, deepCamelCase } from '../../fetchers/_helpers';

/**
 * This file was automatically generated by @gctl/openapi-fetchers
 * Do not modify this file, any changes will be destroyed when
 * the command is rerun.
 */

export type GetMeCategoryFields = readonly string[];

/** Options for GET /me/categories/{category} */
export type GetMeCategoryOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  where: {
    /**
     * The name of the category.
     */
    category: string;
  };
};

/** Result type for GET /me/categories/{category} */
export type GetMeCategoryResult<Paths extends readonly string[]> = unknown;

/**
 * Check if the user follows a category
 * This method determines whether the authenticated user follows the specified category.
 */
export async function getMeCategory<Paths extends GetMeCategoryFields>({
  baseUrl,
  where: { category },
  ...options
}: GetMeCategoryOptions<Paths>): Promise<GetMeCategoryResult<Paths>> {
  return measureLatency('getMeCategory', 'GET', async () => {
    let res = await fetch(`${baseUrl}/me/categories/${category}`, {
      ...options,
      method: 'GET',
    });

    if (!res.ok) {
      throw new NetworkError('A network error occurred', res.status, res);
    }

    if (res.status === 204) {
      return null as unknown as GetMeCategoryResult<Paths>;
    }

    if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
      throw new Error('Expected JSON response');
    }

    let json = await res.json();
    return deepCamelCase(json);
  });
}

export type PutMeCategoryFields = readonly string[];

/** Options for PUT /me/categories/{category} */
export type PutMeCategoryOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  where: {
    /**
     * The name of the category.
     */
    category: string;
  };
};

/** Result type for PUT /me/categories/{category} */
export type PutMeCategoryResult<Paths extends readonly string[]> = unknown;

/**
 * Cause the user to follow a specific category
 * This method causes the authenticated user to follow the specified category.
 */
export async function putMeCategory<Paths extends PutMeCategoryFields>({
  baseUrl,
  where: { category },
  ...options
}: PutMeCategoryOptions<Paths>): Promise<PutMeCategoryResult<Paths>> {
  return measureLatency('putMeCategory', 'PUT', async () => {
    let res = await fetch(`${baseUrl}/me/categories/${category}`, {
      ...options,
      method: 'PUT',
    });

    if (!res.ok) {
      throw new NetworkError('A network error occurred', res.status, res);
    }

    if (res.status === 204) {
      return null as unknown as PutMeCategoryResult<Paths>;
    }

    if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
      throw new Error('Expected JSON response');
    }

    let json = await res.json();
    return deepCamelCase(json);
  });
}

export type DeleteMeCategoryFields = readonly string[];

/** Options for DELETE /me/categories/{category} */
export type DeleteMeCategoryOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  where: {
    /**
     * The name of the category.
     */
    category: string;
  };
};

/** Result type for DELETE /me/categories/{category} */
export type DeleteMeCategoryResult<Paths extends readonly string[]> = unknown;

/**
 * Cause the user to stop following a category
 * This method causes the authenticated user to stop following the specified category.
 */
export async function deleteMeCategory<Paths extends DeleteMeCategoryFields>({
  baseUrl,
  where: { category },
  ...options
}: DeleteMeCategoryOptions<Paths>): Promise<DeleteMeCategoryResult<Paths>> {
  return measureLatency('deleteMeCategory', 'DELETE', async () => {
    let res = await fetch(`${baseUrl}/me/categories/${category}`, {
      ...options,
      method: 'DELETE',
    });

    if (!res.ok) {
      throw new NetworkError('A network error occurred', res.status, res);
    }

    if (res.status === 204) {
      return null as unknown as DeleteMeCategoryResult<Paths>;
    }

    if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
      throw new Error('Expected JSON response');
    }

    let json = await res.json();
    return deepCamelCase(json);
  });
}
